<template>
      <div class="dpf-preview shadow" v-show="template > 0">
            <div class="dfp-form" :class="'template-'+template" v-if="campana" :style="template != 1 ? 'background: url('+ campana.imagen +') 0% 0% / 100% no-repeat rgb(250, 250, 255);': 'inherit'">
                  <div class="dfp-header">
                        <img v-if="template == 1" :src="campana.imagen" alt="Campaña" class="dfp-cover">
                        <!-- <div clyass="dfp-title">{{campana.caption}}</div> -->
                  </div>
                   <div class="fields" :class="{'p-absolute': customPosition}" :style="'bottom:' + fieldsPosition+'px'">
                    <div v-for="field in campana.form.fields" class="dfp-field" :key="'tmpForm_' + field.id">
                        <label :class="{'label-option': field.html == 'input:radio' || field.html == 'input:checkbox'  }">{{field.caption}}</label>
                        <!--TEXT, PASSWORD, EMAIL, NUMBER-->
                        <input min="1" :id="'formField_' + field.id" 
                              :type="setTypeHtml(field.html)" class="dfp-input" 
                              :placeholder="field.placeholder" v-if="field.values.length == 0 && showHtml(field, 'input')"
                              :maxlength="field.maxlength > 0 ? field.maxlength  : 'false'" 
                              :name="'formField_' + field.id" />
                        <!--CHECKBOX RADIO-->
                        <div class="dfp-chekbox" v-if="field.values.length > 0 && showHtml(field, 'input')">
                            <label v-for="(option, index) in field.values" class="dfp-label-check" :for="'formField_' + field.id + '_' + index" :key="'tmpFieldType_'+ index + '_' + field.id">
                                <input :id="'formField_' + field.id + '_' + index" :type="setTypeHtml(field.html)"
                                    class="dfp-input-checkbox" :placeholder="field.placeholder" :name="'formField_' + field.id"
                                    v-model="field.respuesta" :required="field.required">
                                {{option.caption}}
                            </label>
                        </div>
                        <!--SELECT-->
                        <select :ref="'list_' + field.id" class="dfp-input" :placeholder="field.placeholder" v-if="showHtml(field, 'select')" :name="'formField_' + field.id">
                            <option :value="field.placeholder">{{field.caption}}</option>
                            <template v-for="o in field.values">
                                  <option :key="'TmpOptionSlc_' + o.id" :value="o.caption">{{o.caption}}</option>
                            </template>
                        </select>
                        <!--TEXTAREA-->
                        <textarea  :maxlength="field.maxlength > 0 ? field.maxlength  : 'false'" v-if="showHtml(field, 'textarea')" :placeholder="field.placeholder" v-model="field.respuesta"></textarea>                        
                        <div :id="'_error_' + field.id" class="dfp-error dnone" data-placement="left">!</div>
                    </div>
                    <div class="dfp-field">
                        <button class="dfp-submit" type="submit" :style="'background:' + campana.boton.color + ';color:' + campana.boton.textcolor">{{campana.boton.caption}}</button>
                    </div>
                </div>
            </div>
      </div>
</template>
<script>
import _ from "underscore"
export default {
   name: 'Previsualizador',
   props:['campana','template','fieldsPosition', 'customPosition'],
   data() {
      return {
         loading: false,

      }
   },
   methods: {
    setTypeHtml: function (data) {
        const salida = data ? data.split(':') : '';
        return salida[1];
    },
    showHtml: function (data, type) {
        const salida = data.html ? data.html.split(':') : '';
        return !_.contains(salida, type) ? false : true;
    }
   }
}
</script>
<style scoped>
.p-absolute {
    position: absolute;
    width: 100%;
}
</style>
